export const GET_LABEL_PRINTING_DATA_START = "GET_LABEL_PRINTING_DATA_START";
export const GET_LABEL_PRINTING_DATA_SUCCESS =
  "GET_LABEL_PRINTING_DATA_SUCCESS";
export const GET_LABEL_PRINTING_DATA_FAILURE =
  "GET_LABEL_PRINTING_DATA_FAILURE";
